/**
 * O dia de HOJE no fuso da EMPRESA — `"AAAA-MM-DD"`, ou `null` se o fuso não existe.
 *
 * 🔴 **O fuso é o do ITEM, e não o do navegador.** O backend recusa reagendar
 * para uma data anterior a hoje NO FUSO DA EMPRESA; se a tela derivasse o `min`
 * do campo de data do relógio de quem abriu a Fila, ela discordaria da regra que
 * vai recusar — em silêncio, nos poucos fusos e horas em que os dois dias
 * diferem. (O que `QuandoPublicar` proíbe é o `new Date()` lido no fuso do
 * NAVEGADOR; aqui o `Date` só fornece o INSTANTE, e quem o transforma em dia é
 * o `Intl` com o fuso do item.)
 *
 * ⚠️ **`en-CA` porque a ordem dele é `AAAA-MM-DD`** — a mesma que o
 * `<input type="date">` e o corpo da rota usam. `pt-BR` daria `dd/mm/aaaa`, e
 * remontar a string à mão a partir de `formatToParts` seria uma segunda
 * conversão para errar.
 *
 * ⚠️ **Fuso inválido → `null`, não exceção.** `Intl.DateTimeFormat` lança
 * `RangeError`; a tela não pode estourar ao abrir um cartão por causa de um
 * dado do servidor. Sem `min` e sem data inicial, quem recusa é o backend, com a
 * frase dele.
 */
export function hojeNoFuso(fuso: string): string | null {
  try {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: fuso,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date());
  } catch {
    return null;
  }
}

/**
 * `valor` é uma data `AAAA-MM-DD` — e só isso.
 *
 * 🔴 **Achado da revisão final do passo 13 (06/10/2026).** O `<input type="date">`
 * do Chrome aceita ano de 5 ou 6 dígitos: `"20261-10-08" >= "2026-10-06"` é
 * verdadeiro por comparação de TEXTO, o mês recortado vira lixo e a frase da tela
 * saía *"…passa para a fila de undefined."*. Toda conta sobre o texto do campo
 * passa por aqui antes.
 */
export function ehDataIso(valor: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(valor);
}
